import {Text} from "react-native";

export const timeoutText = <Text> 밤 11시 ~ 새벽 4시 사이에는 활동이 불가합니다.</Text>